import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router';
import MainHeader from '../../Components/Header/MainHeader';
import { BASE_URL_API } from '../../References/URLs';
import styles from './OrderPlacedSuccess.module.css';

const OrderPlacedSuccess = () => {
    const { orderIdentifier } = useParams()
    const [orderData, setOrderData] = useState(null)

    const getOrderDetails = async () => {
        const getOrderDetailsResponse = await fetch(BASE_URL_API+"getOrderDetails",
        {
            method : "POST",
            body : JSON.stringify({
                orderIdentifier : orderIdentifier
            })
        })

        if(!getOrderDetailsResponse.ok) {
            console.log("Something went wrong : Server")
        } 

        const getOrderDetailsRespo = await getOrderDetailsResponse.json()
        if(getOrderDetailsRespo.status==="success") {
            setOrderData(getOrderDetailsRespo?.response)
        } else {
            setOrderData(null)
        }
    }


    useEffect(() => {
        getOrderDetails()
    }, [orderIdentifier])
    

    return (
        <div>
            <MainHeader />
            <div className={styles.mainWrapper}>
                <div className={styles.mainContainer}>
                    {/* Success GIF */}
                    <div className={styles.gifWrapper}>
                        <img
                            src="https://www.lappymaker.com/images/greentick-unscreen.gif"
                            alt="Success"
                            className={styles.successGif}
                        />
                    </div>

                    {/* Success Message */}
                    <div className={styles.successMessage}>
                        <h1>Thank You for Your Order!</h1>
                        <p>Your order has been placed successfully.</p>
                    </div>

                    {/* Order Details */}
                    <div className={styles.orderDetails}>
                        <div className={styles.tableTitle} >Order Summary</div>
                        <div>
                            <div className={styles.eachRow}>
                                <div className={styles.eachRowTitle} >Order ID:</div> 
                                <div>{orderData?.orderIdentifier}</div>
                            </div>
                            <div className={styles.eachRow}>
                                <div className={styles.eachRowTitle} >Estimated Delivery:</div>
                                <div>{orderData?.deliveryDate}</div> 
                            </div>
                            <div className={styles.eachRow}>
                                <div className={styles.eachRowTitle} >Total Amount:</div>
                                <div>{orderData?.productsTotal}</div> 
                            </div>
                            <div className={styles.eachRow}>
                                <div className={styles.eachRowTitle} >Payment Mode:</div>
                                <div>{orderData?.paymentMethod}</div> 
                            </div>
                            <div className={styles.eachRow}>
                                <div className={styles.eachRowTitle} >Points Earned:</div>
                                <div>{orderData?.totalPointsEarned}</div> 
                            </div>
                        </div>
                    </div>

                    {/* CTA Buttons */}
                    <div className={styles.ctaButtons}>
                        <Link
                            to={`/`}
                            className={styles.homeButton}
                        >
                            Go to Home
                        </Link>
                        {/* <Link
                            to={`/orders`}
                            className={styles.ordersButton}
                        >
                            View My Orders
                        </Link> */}
                    </div>
                </div>
            </div>
        </div>
    )
};

export default OrderPlacedSuccess;
